export default __webpack_public_path__ + "static/media/edlyft.ecc15aae.png";